import React        from 'react';
import PropTypes    from 'prop-types';
import Translations from '../../../utils/Translations';

class AgeLabel extends React.Component {


	getFormattedAge() {
		const age = Translations.get('VideoGridAge').replace(':age', this.props.age);

		return age.toUpperCase();
	}

	render() {
		if (this.props.age !== 18) {
			return null;
		}

		return (
			<span className="video-grid__item--label --danger">
				{this.getFormattedAge()}
			</span>
		);
	}
}

AgeLabel.propTypes = {
	age: PropTypes.number,
};

AgeLabel.defaultProps = {
	age: 0,
};

export default AgeLabel;